import React, { useState } from "react";
import { AppLayout } from "../../templates";
import { AppPopup, UserList, UserListFilters } from "../../components";
import { Button, Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { userActions, factoryActions, alertActions } from "../../_redux/actions";
import { authorizationService } from "../../_services";
import UserAdd from "../../components/user/UserAdd";
import {
    AssignUserFactoriesPayloadStructure,
    AssignUserRolePayloadStructure,
    CreateUserPayloadStructure, UserListFiltersStructure
} from "../../_models/app.models";
import UserRoleAssign from "../../components/user/UserRoleAssign";
import UserFactoryAssign from "../../components/user/UserFactoryAssign";
import UserFactoryView from "../../components/user/UserFactoryView";
import { APP_CONFIGS } from "../../_constants";
import { utilFunctions } from "../../_helpers";

const UserManagementPage = () => {
    const INITIAL_STATE = {
        addUserPopup: false,
        addUserReset: 0,
        roleAssignPopup: false,
        factoryAssignPopup: false,
        factoryViewPopup: false,
        popupUser: {
            id: null,
            email: null
        }
    }
    const dispatch = useDispatch();
    const [userMgtPageState, setUserMgtPageState] = useState(INITIAL_STATE);
    const userListState = useSelector((state: any) => state.users.userList)
    const plantListState = useSelector((state: any) => state.factories.plantList)

    React.useEffect(() => {
        // Dispatch getUserList action to fetch user list
        dispatch(userActions.getUserList(null,
            () => {
                // Success event
            },
            (error) => {
                // trigger alert onError
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }));
        // Dispatch getAllPlantList action to fetch plant data
        dispatch(factoryActions.getAllPlantList(
            authorizationService.getAuthorizedUser().isAdmin,
            () => { },
            (error) => { dispatch(alertActions.triggerAlert(true, error, 'error')) }
        ));

    }, [])

    // handle add user popup toggle
    const toggleAddUserPopup = (status: boolean, user: any) => {
        setUserMgtPageState({
            ...userMgtPageState,
            addUserPopup: status,
            popupUser: user
        });
    };

    // handle user role assign popup toggle
    const toggleRoleAssignPopup = (status: boolean) => {
        setUserMgtPageState({
            ...userMgtPageState,
            roleAssignPopup: status
        });
    };

    // handle add user factory popup toggle
    const toggleFactoryAssignPopup = (status: boolean) => {
        setUserMgtPageState({
            ...userMgtPageState,
            factoryAssignPopup: status
        });
    };

    // handle view user factory list popup toggle
    const toggleFactoryViewPopup = (status: boolean) => {
        setUserMgtPageState({
            ...userMgtPageState,
            factoryViewPopup: status
        });
    };

    const initUserRoleAssign = (popupStatus, user) => {
        setUserMgtPageState({
            ...userMgtPageState,
            popupUser: user,
            roleAssignPopup: popupStatus
        });
    }

    const initUserFactoryAssign = (popupStatus, user) => {
        setUserMgtPageState({
            ...userMgtPageState,
            popupUser: user,
            factoryAssignPopup: popupStatus
        });
    }

    const initUserFactoryView = (popupStatus, user) => {
        setUserMgtPageState({
            ...userMgtPageState,
            popupUser: user,
            factoryViewPopup: popupStatus
        });
    }
    const initUserEdit = (popupStatus, user) => {
        setUserMgtPageState({
            ...userMgtPageState,
            popupUser: user,
            addUserPopup: popupStatus
        });
    }

    const onFilterChange = (filters: UserListFiltersStructure | null) => {
        dispatch(userActions.getUserList(filters,
            () => { },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }));
    }

    const onFilterClear = () => {
        onFilterChange(null)
    }

    const onAddUser = (data) => {
        const addUserPayload: CreateUserPayloadStructure = {
            id: data.id.value,
            userEmail: data.username.value,
            firstName: data.firstName.value,
            lastName: data.lastName.value,
            tulitaLicenseNo: data.license.value,
            isActive: data.isActive.value,
            userRoleIds: data.roles.value,
            requestedBy: authorizationService.getAuthorizedUser().userEmail
        }
        dispatch(userActions.createUser(addUserPayload, (data, responseMessage) => {
            // reset user add from on user create event (skip user update event)
            if (!userMgtPageState.popupUser) {
                const reset = userMgtPageState.addUserReset + 1;
                setUserMgtPageState({
                    ...userMgtPageState,
                    addUserReset: reset
                })
            }
            dispatch(alertActions.triggerAlert(true, responseMessage, 'success'))
            dispatch(userActions.getUserList(null, () => { }, (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
        }, (error) => {
            dispatch(alertActions.triggerAlert(true, error, 'error'))
        }))
    }

    const onAssignRoles = (roleIds) => {
        const assignRolesPayload: AssignUserRolePayloadStructure = {
            userId: +userMgtPageState.popupUser.id,
            userRoleIds: roleIds,
            updatedBy: authorizationService.getAuthorizedUser().userEmail
        }
        dispatch(userActions.assignUserRole(assignRolesPayload, (data, responseMessage) => {
            setUserMgtPageState({
                ...userMgtPageState,
                roleAssignPopup: false
            });
            dispatch(alertActions.triggerAlert(true, responseMessage, 'success'))
        }, (error) => {
            dispatch(alertActions.triggerAlert(true, error, 'error'))
        }))
    }

    const onAssignFactory = (factoryIds, plant) => {
        const assignFactoriesPayload: AssignUserFactoriesPayloadStructure = {
            userId: +userMgtPageState.popupUser.id,
            plantId: plant,
            userFactoryIds: factoryIds,
            updatedBy: authorizationService.getAuthorizedUser().userEmail
        }
        dispatch(userActions.assignUserFactories(assignFactoriesPayload, (data, responseMessage) => {
            setUserMgtPageState({
                ...userMgtPageState,
                factoryAssignPopup: false
            });
            dispatch(alertActions.triggerAlert(true, responseMessage, 'success'))
        }, (error) => {
            dispatch(alertActions.triggerAlert(true, error, 'error'))
        }))
    }

    return (
        <AppLayout>
            <AppPopup
                open={userMgtPageState.addUserPopup}
                onClose={(status) => toggleAddUserPopup(status, null)}
                maxWidth="sm"
                fullWidth={true}
                title={"Add / Update user"}>
                <UserAdd
                    reset={userMgtPageState.addUserReset}
                    user={userMgtPageState.popupUser}
                    onClose={(status) => toggleAddUserPopup(status, null)}
                    addUser={(data) => onAddUser(data)}
                />
            </AppPopup>

            <AppPopup
                open={userMgtPageState.roleAssignPopup}
                onClose={(status) => toggleRoleAssignPopup(status)}
                maxWidth="sm"
                fullWidth={true}
                title={"Assign Roles"}>
                <UserRoleAssign
                    user={userMgtPageState.popupUser}
                    assignRoles={(roleIds) => onAssignRoles(roleIds)}
                    onClose={(status) => toggleRoleAssignPopup(status)}
                />
            </AppPopup>

            <AppPopup
                open={userMgtPageState.factoryAssignPopup}
                maxWidth="sm"
                fullWidth={true}
                onClose={(status) => toggleFactoryAssignPopup(status)}
                title={"Assign Factories"}>
                <UserFactoryAssign
                    user={userMgtPageState.popupUser}
                    assignFactory={(factories, plant) => onAssignFactory(factories, plant)}
                    onClose={(status) => toggleFactoryAssignPopup(status)}
                />
            </AppPopup>

            <AppPopup
                open={userMgtPageState.factoryViewPopup}
                onClose={(status) => toggleFactoryViewPopup(status)}
                maxWidth="sm"
                fullWidth={true}
                title={"Assigned Factories"}>
                <UserFactoryView
                    user={userMgtPageState.popupUser}
                    onClose={(status) => toggleFactoryViewPopup(status)}
                />
            </AppPopup>


            <Grid container className={'appPageHeader'}>
                <Grid container item xs={12} sm={12} md={7} lg={7} justify="flex-start" alignContent="center">
                    <span className={'pageTitle'}>User <b>Management</b></span>
                </Grid>
                <Grid container item xs={12} sm={12} md={5} lg={5} justify="flex-end" alignContent="center">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => toggleAddUserPopup(true, null)}
                    >Add Users</Button>
                </Grid>
            </Grid>

            <div className="appPageContent">
                <UserListFilters
                    plants={plantListState.data}
                    onFilterChange={onFilterChange}
                    onFilterClear={onFilterClear}
                />
                <UserList
                    onAssignRoleTrigger={(popupStatus, user) => initUserRoleAssign(popupStatus, user)}
                    onAssignFactoryTrigger={(popupStatus, user) => initUserFactoryAssign(popupStatus, user)}
                    onViewFactoryTrigger={(popupStatus, user) => initUserFactoryView(popupStatus, user)}
                    onUserEditTrigger={(popupStatus, user) => initUserEdit(popupStatus, user)}
                    isWebview={utilFunctions.isWebView(navigator.userAgent, APP_CONFIGS.TULITA_APP_USER_AGENT)}
                    data={userListState.data}
                    isLoading={userListState.isLoading}
                />
            </div>
        </AppLayout>
    );
}

export default UserManagementPage;
